import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import { Steps, Step } from '..';

/**
 * StepBar
 *
 * This component is in charge of displaying
 * a stepBar
 *
 * @return {jsx}
 */
export const StepBar = ({ step, t }) => (
  <Steps current={step.current}>
    <Step url="/informations">
      <span> {t('navigation.informations')}</span>
    </Step>
    <Step url="/order">
      <span> {t('navigation.order')}</span>
    </Step>
    <Step url="/delivery">
      <span> {t('navigation.delivery')}</span>
    </Step>
    <Step url="/training">
      <span> {t('navigation.training')}</span>
    </Step>
  </Steps>
);

/**
 * PropTypes Validation
 */
const { object, func } = PropTypes;
StepBar.propTypes = {
  step: object.isRequired,
  t: func.isRequired,
};

/** Defines the mapping Redux store to props. */
const mapStateToProps = ({ step }) => {
  return {
    step,
  };
};

const StepBarConnect = connect(mapStateToProps)(StepBar);

export default translate('translations')(StepBarConnect);



// WEBPACK FOOTER //
// ./src/components/StepBar/index.js